import { Text, AccordionPanel } from '@doda/io-react/common';
import styles from './index.module.scss';

/**
 * JobOfferKindAgentのパーツ、AccordionItemのProps
 */
interface Props {
  title: string;
  caption?: string;
  children: React.ReactNode;
}

/**
 * 応募方法（エージェント）のAccordionItem
 */
export const AccordionItem: React.FC<Props> = ({
  title,
  caption,
  children,
}: Props) => {
  return (
    <AccordionPanel
      className={styles['jobSearchDetail-jobOfferKindAgent__accordionTitle']}
      colorType="white"
      title={title}
    >
      <span
        className={
          styles['jobSearchDetail-jobOfferKindAgent__accordionContent']
        }
      >
        <Text color="black_pc" size="14--articlePC" as="span">
          {children}
        </Text>
        {caption !== undefined && (
          <Text color="gray" size="10" as="span">
            {caption}
          </Text>
        )}
      </span>
    </AccordionPanel>
  );
};
